// https://gist.github.com/addyosmani/1122546
/* !
 * isVis - v0.5.5 Aug 2011 - Page Visibility API Polyfill
 * isVis - v0.5.5-fixed-Termi 03.2015 - fixed by Egor Halimonenko
 * Copyright (c) 2011 Addy Osmani
 * Dual licensed under the MIT and GPL licenses.
 */

import { noop } from 'reactApp/utils/helpers';

export class Visibly {
    private isInited = false;
    private visibilityState = 'visibilityState';
    private visibilityChange = 'visibilitychange';
    private hidden = 'hidden';
    private onVisibleTimer = noop;
    private updateTimeMs = 2 * 60 * 1000;

    private updateInterval: any = null;
    private isHidden = false;

    public init({ onVisibleTimer, updateTimeMs }) {
        if (this.isInited) {
            return;
        }

        this.isInited = true;
        this.updateTimeMs = updateTimeMs;
        this.onVisibleTimer = onVisibleTimer;

        if (!this.supports()) {
            /* if no native page visibility support found..*/
            if ('addEventListener' in document) {
                /* for browsers without focusin/out support eg. firefox, opera use focus/blur*/
                /* window used instead of doc as Opera complains otherwise*/
                window.addEventListener('focus', this.onVisible, true);
                window.addEventListener('blur', this.onHidden, true);
            } else if (window['attachEvent']) {
                /* IE <10s most reliable focus events are onfocusin/onfocusout*/
                window['attachEvent']('onfocusin', this.onVisible);
                window['attachEvent']('onfocusout', this.onHidden);
            }
        } else {
            /* switch support based on prefix*/
            document.addEventListener(this.visibilityChange, this.nativeSwitch, true);
        }

        this.setUpdateTimer();
    }

    private supports() {
        if (document['hidden'] !== void 0) {
            // native
            return true;
        } else if (document['webkitHidden'] !== void 0) {
            this.visibilityState = 'webkitVisibilityState';
            this.visibilityChange = 'webkitvisibilitychange';
            this.hidden = 'webkitHidden';
            return true;
        } else if (document['msHidden'] !== void 0) {
            this.visibilityState = 'msVisibilityState';
            this.visibilityChange = 'msvisibilitychange';
            this.hidden = 'msHidden';
            return true;
        } else if (document['mozHidden'] !== void 0) {
            this.visibilityState = 'mozVisibilityState';
            this.visibilityChange = 'mozvisibilitychange';
            this.hidden = 'mozHidden';
            return true;
        }

        return false;
    }

    private onVisible = () => {
        this.isHidden = false;
        if (this.updateInterval) {
            clearInterval(this.updateInterval);
        }
        this.setUpdateTimer();
        this.onVisibleTimer();
    };

    private onHidden = () => {
        this.isHidden = true;
        if (this.updateInterval) {
            clearInterval(this.updateInterval);
            this.updateInterval = null;
        }
    };

    private setUpdateTimer = () => {
        this.updateInterval = setInterval(() => {
            if (!this.isHidden) {
                this.onVisibleTimer();
            }
        }, this.updateTimeMs);
    };

    private nativeSwitch = () => (document[this.hidden] === true ? this.onHidden() : this.onVisible());
}
